export default __webpack_public_path__ + "static/media/download.215d314e.svg";